export default __webpack_public_path__ + "static/weizmann-rash-1d09ec3bf418cb6afcce8ecfb55e7634.png";